/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import ReactDOM from 'react-dom';
import { AuthContext } from 'context/AuthContext';
import AppLayout from './components/AppLayout';
import 'css/essential.css';

function App() {
  return (
    <AuthContext>
      <AppLayout />
    </AuthContext>
  );
}

ReactDOM.render(<App />, document.getElementById('root'));
